import type { parseFilterModel } from '@/lib/createAgGridDatasource';
import { buildDownloadOptions as buildDownloadOptionsShared, type SortColumnState } from '@/lib/downloadOptions';
import type { ProteoformSampleSummariesDownloadOptions } from '@/services/samples';
import type { ProteoformSampleSummaryFilters, ProteoformSampleSummarySortField } from '@/types';

export const VALID_SORT_FIELDS: readonly ProteoformSampleSummarySortField[] = [
  'sample_name',
  'sample_group',
  'num_proteoform_groups',
  'num_ptms',
  'num_isoforms',
  'instrument_run_name',
  'assay_friendly_name',
  'species',
  'created_at',
  'created_by_full_name',
];

const VALID_FILTER_FIELDS: readonly (keyof ProteoformSampleSummaryFilters)[] = [
  'sample_name',
  'sample_group',
  'instrument_run_name',
  'assay_friendly_name',
  'created_by_full_name',
  'num_proteoform_groups',
  'num_ptms',
  'num_isoforms',
  'species',
  'created_at',
];

/** No boolean filter fields, unlike the Tau detail grid: `species` is the only set filter here and
 *  its values are enum strings, which the endpoint's equality contract takes as-is. */
export function buildAssaySamplesDownloadOptions(
  columnState: readonly SortColumnState[],
  filterModel: Parameters<typeof parseFilterModel>[0],
  assayId: string,
  thresholdCpm: number,
): ProteoformSampleSummariesDownloadOptions {
  const { sortBy, sortOrder, filters } = buildDownloadOptionsShared<
    ProteoformSampleSummarySortField,
    ProteoformSampleSummaryFilters
  >(columnState, filterModel, VALID_SORT_FIELDS, VALID_FILTER_FIELDS);

  return { assayId, filters, sortBy, sortOrder, thresholdCpm };
}
